import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link, withRouter } from 'react-router-dom';
import get from 'lodash/get';

import numberWithSpace from 'rebook/apps/utils/text/numberWithSpace';
import uuid4 from 'rebook/apps/utils/random/uuid4';

import styles from './style.scss';


const EmptyCatalogAsideMenu = () => (
  <React.Fragment>
    <div className={styles.titleEmpty} />
    <div className={styles.subTitleEmpty} />
    <div className={styles.nicheItemEmpty} />
    <div className={styles.line} />
    <div className={styles.nicheItemEmpty} />
    <div className={styles.line} />
    <div className={styles.nicheItemEmpty} />
    <div className={styles.line} />
    <div className={styles.nicheItemEmpty} />
    <div className={styles.line} />
    <div className={styles.nicheItemEmpty} />
  </React.Fragment>
);

const CatalogAsideMenu = ({ items, title, urlPattern, passState, extraClassName, ...props }) => {
  const activePathname = get(props, 'location.pathname', '');

  return (
    <div className={classNames('billetContainer', styles.nicheListContainer, extraClassName)}>
      {items
        ? (
          <React.Fragment>
            {title && typeof(title) === 'string'
              ? <div className="title-2">{title}</div>
              : title
            }
            {items.map((item, index) => {
              let url = passState
                ? { pathname: urlPattern(item.slug, index), state: { niche: item } }
                : urlPattern(item.slug, index);

              if (typeof url === 'string') {
                if (url.substr(-1) !== '/') {
                  url += '/';
                }
              }
              else {
                if (get(url, 'pathname', '/').substr(-1) !== '/') {
                  url.pathname += '/';
                }
              }

              return (
                <div className={styles.nicheItem} key={uuid4()}>
                  <Link to={url}>
                    <div className={styles.nicheName}>
                      <span className={classNames(
                        'link',
                        { activeLink: activePathname === urlPattern(item.slug, index) }
                      )}>
                        <span dangerouslySetInnerHTML={{ __html: item.name }} />
                      </span>
                      <span className={styles.nicheBookCount}>
                        {numberWithSpace(item.active_book_count)}
                      </span>
                    </div>
                  </Link>
                </div>
              );
            })}
          </React.Fragment>
        )
        : <EmptyCatalogAsideMenu />
      }
    </div>
  );
};

CatalogAsideMenu.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  list: PropTypes.array,
  urlPattern: PropTypes.func,
  passState: PropTypes.bool,
  extraClassName: PropTypes.string,
  keyPattern: PropTypes.string,
};

CatalogAsideMenu.defaultProps = {
  title: '',
  list: [],
  passState: false,
  extraClassName: '',
  urlPattern: () => {},
};

export default withRouter(CatalogAsideMenu);
